<div class="chrome-tabs">
  <div class="chrome-tabs-content">
    <div
      class="chrome-tab"
      *ngFor="let tab of tabs"
      (click)="selectTab(tab)"
      active
      [id]="tab.tabId"
      [class.chrome-tab-current]="tab.active"
    >
      <div class="chrome-tab-dividers"></div>
      <div class="chrome-tab-background">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <symbol id="chrome-tab-geometry-left" viewBox="0 0 214 36">
              <path d="M17 0h197v36H0v-2c4.5 0 9-3.5 9-8V8c0-4.5 3.5-8 8-8z" />
            </symbol>
            <symbol id="chrome-tab-geometry-right" viewBox="0 0 214 36">
              <use xlink:href="#chrome-tab-geometry-left" />
            </symbol>
            <clipPath id="crop">
              <rect class="mask" width="100%" height="100%" x="0" />
            </clipPath>
          </defs>
          <svg width="52%" height="100%">
            <use
              xlink:href="#chrome-tab-geometry-left"
              width="214"
              height="36"
              class="chrome-tab-geometry"
            />
          </svg>
          <g transform="scale(-1, 1)">
            <svg width="52%" height="100%" x="-100%" y="0">
              <use
                xlink:href="#chrome-tab-geometry-right"
                width="214"
                height="36"
                class="chrome-tab-geometry"
              />
            </svg>
          </g>
        </svg>
      </div>
      <div class="chrome-tab-content">
        <div class="chrome-tab-title">{{ tab.title | translate }}</div>
        <div class="chrome-tab-drag-handle"></div>
      </div>
    </div>
    <div
      class="chrome-tab"
      (mouseenter)="mouseEnter($event, tab)"
      (mouseleave)="mouseLeave()"
      (contextmenu)="contextmenu($event, tab)"
      (click)="selectTab(tab)"
      (mouseup)="mouseUp($event, tab)"
      *ngFor="let tab of dynamicTabs; let i = index"
      [id]="tab.tabId"
      [class.chrome-tab-current]="tab.active"
    >
      <div class="chrome-tab-dividers"></div>
      <div class="chrome-tab-background">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <symbol id="chrome-tab-geometry-left" viewBox="0 0 214 36">
              <path d="M17 0h197v36H0v-2c4.5 0 9-3.5 9-8V8c0-4.5 3.5-8 8-8z" />
            </symbol>
            <symbol id="chrome-tab-geometry-right" viewBox="0 0 214 36">
              <use xlink:href="#chrome-tab-geometry-left" />
            </symbol>
            <clipPath id="crop">
              <rect class="mask" width="100%" height="100%" x="0" />
            </clipPath>
          </defs>
          <svg width="52%" height="100%">
            <use
              xlink:href="#chrome-tab-geometry-left"
              width="214"
              height="36"
              class="chrome-tab-geometry"
            />
          </svg>
          <g transform="scale(-1, 1)">
            <svg width="52%" height="100%" x="-100%" y="0">
              <use
                xlink:href="#chrome-tab-geometry-right"
                width="214"
                height="36"
                class="chrome-tab-geometry"
              />
            </svg>
          </g>
        </svg>
      </div>
      <div class="chrome-tab-content">
        <div class="chrome-tab-title">
          {{ tab.title | translate }} [{{ tab.childTemplate.mode | translate }}]
        </div>
        <div class="chrome-tab-drag-handle"></div>
        <div class="chrome-tab-close" (click)="closeTab(tab)"></div>
      </div>
    </div>
  </div>
  <div class="chrome-tabs-bottom-bar"></div>
</div>
<ul
  class="grid-list-menu-tab wj-dropdown-panel wj-listbox wj-content"
  role="menu"
  aria-labelledby="dropdownMenu"
  klClickOutside
  (clickOutside)="showContextMenu = false"
  [class.active]="showContextMenu"
  [ngStyle]="{ 'left.px': contextMenuX, 'top.px': contextMenuY }"
>
  <li class="wj-listbox-item" (click)="closeTab(currentTab)">
    <span class="grid-dropdown-span">{{ "close" | translate }}</span>
  </li>
  <li class="wj-listbox-item" (click)="closeOtherTabs()">
    <span class="grid-dropdown-span">{{ "close_other_tabs" | translate }}</span>
  </li>
  <li
    class="wj-listbox-item"
    (click)="closeTabsToTheRight()"
    [hidden]="currentTabIndex === dynamicTabs.length - 1"
  >
    <span class="grid-dropdown-span">{{
      "close_tabs_to_the_right" | translate
    }}</span>
  </li>
  <li
    class="wj-listbox-item"
    [hidden]="currentTabIndex === 0"
    (click)="closeTabsToTheLeft()"
  >
    <span class="grid-dropdown-span">{{
      "close_tabs_to_the_left" | translate
    }}</span>
  </li>
  <li
    class="context-menu-item context-menu-separator context-menu-not-selectable"
  ></li>
  <li class="wj-listbox-item" (click)="closeAllTab()">
    <span class="grid-dropdown-span">{{ "close_all" | translate }}</span>
  </li>
</ul>

<ng-content></ng-content>
<ng-template dynamic-tabs #container></ng-template>
<kl-tabs-hover
  *ngIf="showHoverTitle"
  [positions]="tabHoverTitlePositions"
  [tabTitle]="tabTitle"
  [tabMode]="tabMode"
></kl-tabs-hover>
